import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
} from "@mui/material";
import { getEditorList } from "../../apis/apiList/userApi";
import { useNavigate } from "react-router-dom";
import AddEditorModal from "../../components/admin-component/AddEditorModal";
import EditEditorModal from "../../components/admin-component/EditEditorModal";

const ITEMS_PER_PAGE = 10;

export default function EditorManagement() {
  const [editorList, setEditorList] = useState([]);
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedEditor, setSelectedEditor] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchEditors() {
      try {
        const res = await getEditorList();
        setEditorList(res.data || []);
      } catch (error) {
        console.error("Error fetching editor list:", error);
      }
    }

    fetchEditors();
  }, []);

  const handleEdit = (editor) => {
    setSelectedEditor(editor);
    // You can navigate to edit page or open a modal
    console.log("Edit clicked for:", editor);

  };

  const paginatedEditors = editorList.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const handleSubmit = (data) => {
    console.log("Form Submitted:", data);
    setEditorList((prev) => [data, ...prev]);
  };

  const handleEditEditor = (editorNewDetail) => {
    // setSelectedEditor(editor);
    // setOpenEditModal(true);
    console.log(editorNewDetail)
    const updatedEditorList = editorList.map(editor => {
      if (editor._id == editorNewDetail._id) {
        return editorNewDetail;
      }
      return editor;
    });
    setEditorList(updatedEditorList);
  };


  return (
    <Box sx={{ px: 3, py: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3 }}>
          Editor List
        </Typography>

        <Button variant="contained" color="primary" onClick={() => {setOpen(true)}}>
          Add New Editor
        </Button>
      </Box>

      <Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#495967" }}>
                <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                <TableCell sx={{ color: "#fff" }}>Phone</TableCell>
                <TableCell sx={{ color: "#fff" }}>Job Title</TableCell>
                <TableCell sx={{ color: "#fff" }}>Pay Per Project</TableCell>
                <TableCell sx={{ color: "#fff" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedEditors.length > 0 ? (
                paginatedEditors.map((editor) => (
                  <TableRow key={editor._id}>
                    <TableCell
                      sx={{ cursor: "pointer" }}
                      onClick={() => navigate(`/manage/editor/${editor._id}`)}
                    >
                      {editor.firstName} {editor.lastName}
                    </TableCell>
                    <TableCell>{editor.email}</TableCell>
                    <TableCell>{editor.phone ? editor.phone : "-"}</TableCell>
                    <TableCell>{editor.jobTitle}</TableCell>
                    <TableCell>
                      {editor.ratePerProject
                        ? `$${editor.ratePerProject}`
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>{ handleEdit(editor); setOpenEditModal(true)}}
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No editors found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {editorList.length > ITEMS_PER_PAGE && (
          <Box mt={2} display="flex" justifyContent="center">
            <Pagination
              count={Math.ceil(editorList.length / ITEMS_PER_PAGE)}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Box>
        )}
      </Box>

      <AddEditorModal
        open={open}
        handleClose={() => setOpen(false)}
        onSubmit={handleSubmit}
      />

      <EditEditorModal open={openEditModal} handleClose={() => setOpenEditModal(false)} editor={selectedEditor} onSubmit={handleEditEditor} />
    </Box>
  );
}
